import { ReactNode } from 'react';
import { TabPanelStyled } from './styled';

interface TabPanelProps {
  children: ReactNode;
  isActive: boolean;
  className?: string;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, className = '', isActive, ...otherProps } = props;

  return (
    <TabPanelStyled isActive={isActive} role="tabpanel" {...otherProps} className={className}>
      {children}
    </TabPanelStyled>
  );
};
